import axios from 'axios';
import { API_CONFIG } from '../config/api';

// 쿠키에서 값 가져오기
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

// CSRF 토큰 가져오기 (쿠키 또는 세션 스토리지에서)
function getCsrfToken() {
  // 쿠키에서 먼저 시도
  let token = getCookie('csrftoken');
  if (!token) {
    // 쿠키에 없으면 세션 스토리지에서 확인
    token = sessionStorage.getItem('csrftoken');
  }
  return token;
}

// CSRF 토큰을 백엔드에서 가져오기
export async function fetchCsrfToken() {
  try {
    const response = await axios.get(`${API_CONFIG.BASE_URL}/auth/csrf-token/`, {
      withCredentials: true,
    });
    if (response.data.csrfToken) {
      sessionStorage.setItem('csrftoken', response.data.csrfToken);
    }
    return response.data.csrfToken;
  } catch (error) {
    console.error('CSRF 토큰 가져오기 실패:', error);
    return null;
  }
}

// 앱 시작 시 CSRF 토큰 가져오기
if (typeof window !== 'undefined') {
  fetchCsrfToken();
}

// axios 인스턴스 생성
const api = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  withCredentials: true, // Django 세션을 위한 쿠키 전송
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터
api.interceptors.request.use(
  (config) => {
    // POST, PUT, DELETE, PATCH 요청에 CSRF 토큰 추가
    const csrftoken = getCsrfToken();
    if (csrftoken && ['post', 'put', 'delete', 'patch'].includes(config.method?.toLowerCase())) {
      config.headers['X-CSRFToken'] = csrftoken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || '';
      const isAuthRequest = requestUrl.includes('/auth/login/')
        || requestUrl.includes('/auth/find-id/')
        || requestUrl.includes('/auth/find-password/');
      const onLoginPage = window.location.pathname === '/login';

      if (!isAuthRequest && !onLoginPage) {
        // 인증 오류 시 로그인 페이지로 리다이렉트
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

